module.exports = __webpack_public_path__ + "media/images/photos/photo-28-bc1dc0b28198189225dfc0b43d5a4b6f.jpg";